export default {"src":"/_next/static/media/thunderstarleft.b6735d0f.svg","height":151,"width":215,"blurWidth":0,"blurHeight":0};